var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column grey darken-2 item"},[_c('video',{staticClass:"black",attrs:{"src":_vm.files + _vm.video,"autoplay":"","loop":"","muted":""},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }